const AMD_REQUIRED_SERVICES = [
    "Psychiatry",
    "Psychiatric Counseling",
    "Medication Management",
    "In-Person Med Management",
    "In-Person Psych Counseling",
    "Nutrition Counseling",
    "Ketamine Assisted Psychotherapy",
    "Ketamine Assisted Psychotherapy (Evaluation)",
    "Ketamine Assisted Psychotherapy (Therapy Intake)",
];

interface AppointmentAmdCheck {
    client_added_to_amd?: Date | null;
}

type AmdStatus =
    | {
          status: "not-applicable";
          earliestAddedDate: null;
      }
    | {
          status: "incomplete";
          earliestAddedDate: null;
      }
    | {
          status: "complete";
          earliestAddedDate: Date;
      };

export function isAmdRequired(
    appointmentPractice: string | null | undefined,
    requestedService: string
): boolean {
    return (
        appointmentPractice === "CHP" &&
        AMD_REQUIRED_SERVICES.includes(requestedService)
    );
}

export function getAmdStatus(
    requiredAppointmentIds: string[],
    appointmentChecks: Record<string, AppointmentAmdCheck> = {}
): AmdStatus {
    if (requiredAppointmentIds.length === 0) {
        return {
            status: "not-applicable",
            earliestAddedDate: null,
        };
    }

    const addedDates = requiredAppointmentIds
        .map((id) => appointmentChecks[id]?.client_added_to_amd)
        .filter((date): date is Date => Boolean(date));

    if (addedDates.length !== requiredAppointmentIds.length) {
        return {
            status: "incomplete",
            earliestAddedDate: null,
        };
    }

    return {
        status: "complete",
        earliestAddedDate: addedDates.reduce((earliest, current) =>
            current.getTime() < earliest.getTime() ? current : earliest
        ),
    };
}
